import React, { useState, useEffect } from "react";
import axios from "../../api/axios.js";
import { getFetchOptions } from "../../js/utility.js";

const ValidateEmail = () => {
  const token = window.location.pathname.split("/").pop();

  const handleValidateEmail = async () => {
    const fetchCheckOptions = getFetchOptions(
      "application/json",
      { token },
      "POST"
    );
    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/validateEmail`,
      fetchCheckOptions
    )
      .then((response) => {
        response.json().then((result) => {
          if (!result.error) {
            alert("Email validata con successo");
            window.location.href = "/login";
          } else {
            alert("Errore durante la validazione dell'email: " + result.error);
            window.location.href = "/login";
          }
        });
      })
      .catch((error) => {
        alert("Errore durante la validazione dell'email: " + error.message);
      });
  };
  // Call the validation function when the component mounts
  const hasRun = React.useRef(false);
  useEffect(() => {
    if (!hasRun.current) {
      handleValidateEmail();
      hasRun.current = true;
    }
  }, []);

  return <div>Validazione email in corso....</div>;
};

export default ValidateEmail;
